import { resolveInternalHref } from '../../medleveSeo/publishable'
import { BRANDS, getEntryByPath, GLP1_HUB_SLUG, MEDICAL_TEAM_PATH, MOLECULES } from '../../medleveSeo/registry'
import { HOME_ABOUT_ID } from './constants'

export interface HomeFooterLink {
  label: string
  href: string
}

/**
 * Registry-backed footer targets, in the PRD §32 order: Equipe médica, GLP-1, moléculas, marcas, Dados.
 * (PRD §32 also lists "Blog": Medleve has no blog route today, so there is nothing to link.)
 */
const REGISTRY_PATHS: string[] = [
  MEDICAL_TEAM_PATH,
  `/${GLP1_HUB_SLUG}`,
  ...MOLECULES.map(({ path }) => path),
  ...BRANDS.map(({ path }) => path),
  '/dados'
]

/** Footer wording where it differs from the registry entry name. */
const LABEL_OVERRIDES: Record<string, string> = { '/dados': 'Dados' }

/**
 * Legal pages that already exist and are brand-aware. Not edited by this project (PRD §5).
 */
const LEGAL_LINKS: HomeFooterLink[] = [
  { label: 'Termos', href: '/termos-e-condicoes' },
  { label: 'Privacidade', href: '/politica-de-privacidade' }
]

/**
 * Footer navigation of the organic homepage (PRD §32) — ONLY URLs that exist today.
 * Registry targets go through `resolveInternalHref`, so an unpublished page (PRD §85) is simply absent
 * and enters the footer by itself the day its registry entry becomes publishable.
 */
export const getHomeFooterLinks = (): HomeFooterLink[] => [
  { label: 'Sobre', href: `/#${HOME_ABOUT_ID}` },
  ...REGISTRY_PATHS.reduce<HomeFooterLink[]>((links, path) => {
    const href = resolveInternalHref(path)
    const entry = getEntryByPath(path)
    return href && entry ? [...links, { label: LABEL_OVERRIDES[path] ?? entry.name, href }] : links
  }, []),
  ...LEGAL_LINKS
]
